/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_No_Deduction_HistoryInputs */

const en_cargos_no_deduction_history = /** @type {(inputs: Cargos_No_Deduction_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No order-linked deduction history for this cargo.`)
};

const es_cargos_no_deduction_history = /** @type {(inputs: Cargos_No_Deduction_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay historial de deducciones vinculadas a pedidos para esta carga.`)
};

/**
* | output |
* | --- |
* | "No order-linked deduction history for this cargo." |
*
* @param {Cargos_No_Deduction_HistoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_no_deduction_history = /** @type {((inputs?: Cargos_No_Deduction_HistoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_No_Deduction_HistoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_no_deduction_history(inputs)
	return es_cargos_no_deduction_history(inputs)
});